import moment from "moment";
import React from "react";
import Table from "../../../components/CsplTable/CsplTable";
import {
  calculateGrossAmountFromNetAmountSourceWise,
  calculateNetAmountFromGrossAmount,
  calculateNextPaymentDate,
  getVestedBalanceWithoutVestingMultiplier,
  getFilteredRkData,
} from "./DistributionConstantsAndFunctions";
const columns = [
  {
    label: "Installment",
    columnName: "installment",
    width: "20%",
  },
  {
    label: "Date",
    columnName: "date",
    width: "20%",
  },
  {
    label: "Net payment",
    columnName: "netPayment",
    width: "20%",
  },
  {
    label: "Gross payment",
    columnName: "grossPayment",
    width: "20%",
  },
  {
    label: "Account balance",
    columnName: "accountBalance",
    width: "20%",
  },
];

const getInstallmentMultiplier = (frequency) => {
  switch (frequency) {
    case 4:
      return 12;
    case 5:
      return 4;
    case 6:
      return 2;
    case 7:
      return 1;
  }
};

function PaymentScheduleTable(props) {
  const {
    values,
    selectedWithdrawalPlanSetUp,
    fields,
    periodicPaymentFrequency,
    withdrawalTransactionForPeriodicPayment,
    withdrawalRequestData,
    periodicPaymentDataSelected,
    sourceBalances,
    ...rest
  } = props;
  const filteredSourceBalances = getFilteredRkData(
    sourceBalances,
    false,
    withdrawalRequestData,
    withdrawalTransactionForPeriodicPayment,
    0
  );
  const periodicPaymentAmount =
    periodicPaymentDataSelected?.grossAmount ??
    calculateGrossAmountFromNetAmountSourceWise(
      withdrawalTransactionForPeriodicPayment,
      withdrawalRequestData,
      filteredSourceBalances
    );

  const periodicPaymentAmountApplicable =
    values[fields.typeOfExpectancy] === 2
      ? values[fields.netAmountRequested] /
        (values[fields.numberOfInstallments] *
          getInstallmentMultiplier(periodicPaymentFrequency))
      : periodicPaymentAmount;

  const effectiveNetAmount = getVestedBalanceWithoutVestingMultiplier(
    calculateNetAmountFromGrossAmount(
      withdrawalTransactionForPeriodicPayment,
      withdrawalRequestData,
      filteredSourceBalances
    )
  );

  const firstRepaymentDate =
    values[fields.dateOfAnnuityPayments] === 1
      ? calculateNextPaymentDate(selectedWithdrawalPlanSetUp)
      : values[fields.nextRepaymentDate];
  let requestedAmount = parseInt(values[fields.netAmountRequested]);

  let installment = 1;
  let scheduledDate = moment(firstRepaymentDate);

  const calculatePeriodicScheduleData = () => {
    if (
      !periodicPaymentAmountApplicable ||
      !firstRepaymentDate ||
      !periodicPaymentFrequency
    )
      return [];

    let periodicScheduleData = [];
    const calculateNextScheduleDate = (frequencyType) => {
      switch (frequencyType) {
        case 4:
          return scheduledDate.add(1, "M");
        case 5:
          return scheduledDate.add(3, "M");
        case 6:
          return scheduledDate.add(6, "M");
        case 7:
          return scheduledDate.add(1, "years");
        default:
          return scheduledDate;
      }
    };
    while (requestedAmount > 0) {
      periodicScheduleData.push({
        installment: installment,
        date: scheduledDate.format("MM/DD/YYYY"),
        netPayment: effectiveNetAmount?.toFixed(2),
        grossPayment: periodicPaymentAmountApplicable?.toFixed(2),
        accountBalance: requestedAmount?.toFixed(2),
      });
      installment++;
      scheduledDate = calculateNextScheduleDate(periodicPaymentFrequency);
      requestedAmount = requestedAmount - periodicPaymentAmountApplicable;
    }
    return periodicScheduleData;
  };
  const periodicScheduleData = calculatePeriodicScheduleData();
  return (
    <div className="source-allocation-table-component">
      <div className="header-tile pl-2 pr-2 w-100">
        {columns.map((_, ind) => (
          <div style={{ width: _?.width }} className="withdrawal-Text-Color">
            {_?.label} <i className="fas fa-sort"></i>
          </div>
        ))}
      </div>
      <Table className="source-allocation-table-component">
        <Table.Tbody>
          {(periodicScheduleData ?? []).map((_, ind) => {
            return (
              <Table.Tr
                className={ind % 2 === 0 ? "grey-style" : "white-style"}
              >
                {columns.map((col, index) => {
                  return (
                    <Table.Td style={{ width: col.width }}>
                      <div style={{ whiteSpace: "nowrap" }}>
                        {_[col.columnName]}
                      </div>
                    </Table.Td>
                  );
                })}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </div>
  );
}

export default PaymentScheduleTable;
